/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmailContactDto } from '../models';
/**
 * EmailContactsApi - axios parameter creator
 */
export const EmailContactsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all email contacts
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailContacts: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getEmailContacts', 'userId', userId)
            const localVarPath = `/api/users/{userId}/emails/contacts`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailContactsApi - functional programming interface
 */
export const EmailContactsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailContactsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all email contacts
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailContacts(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EmailContactDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailContacts(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailContactsApi.getEmailContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailContactsApi - factory interface
 */
export const EmailContactsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailContactsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all email contacts
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailContacts(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmailContactDto>> {
            return localVarFp.getEmailContacts(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailContactsApi - interface
 */
export interface EmailContactsApiInterface {
    /**
     * 
     * @summary Get all email contacts
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmailContacts(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<EmailContactDto>>;

}

/**
 * EmailContactsApi - object-oriented interface
 */
export class EmailContactsApi extends BaseAPI implements EmailContactsApiInterface {
    /**
     * 
     * @summary Get all email contacts
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEmailContacts(userId: string, options?: RawAxiosRequestConfig) {
        return EmailContactsApiFp(this.configuration).getEmailContacts(userId, options).then((request) => request(this.axios, this.basePath));
    }
}

